import React, { useEffect, useState } from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { Slider } from "@mui/material";
import styled from "styled-components";
import { COLORS, SIZES } from "theme";

export const PrettoSlider = styled(Slider)({
  color: COLORS.lightGrey,
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
    height: 4,
    width: "100px",
    backgroundColor: "#9CCDFB",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#9CCDFB",
    border: "2px solid #9CCDFB",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    color: "#000000",
    fontWeight: "bold",

    backgroundColor: "#9CCDFB",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

const Payload = ({ small, selectedVehicle }) => {
  const [value, setValue] = useState(688);

  useEffect(() => {
    selectedVehicle === 'StormEV' ? setValue(1250) : setValue(688);
  }, [selectedVehicle])

  return (
    <Box
      display="flex"
      flexDirection="column"
      marginTop={small ? "0px" : "10px"}
    >
      <Box background="#1C1C1C" b={small ? "none" : "1px solid #333333"}>
        <Box margin="24px">
          <Text
            fontSize={small ? SIZES.fourteen : "16px"}
            fontWeight="bold"
            textColor="white"
          >
            Payload
          </Text>

          <Box>
            <Box>
              <PrettoSlider
                valueLabelDisplay="on"
                aria-label="pretto slider"
                min={10}
                max={value}
                value={value}
                step={10}

              />
              <Box display="flex" justifyContent="space-between" color="white">
                <Text fontSize={small ? "14px" : "14px"} margin="0">
                  10 kgs
                </Text>
                <Text fontSize={small ? "14px" : "14px"} margin="0">
                  {selectedVehicle === 'StormEV' ? <div>1250 kgs</div> : <div>688 kgs</div>}
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Payload;
